import React from 'react';
import ChatInterface from './components/ChatInterface';
import './index.css';

function App() {
  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <h1>🙏 Prayer Flow</h1>
            <p>AI-powered prayer companion grounded in Scripture</p>
          </div>
          <div className="header-right">
            <div className="donate-section">
              <p className="donate-text">Support Prayer Flow</p>
              <stripe-buy-button
                buy-button-id="buy_btn_1S6hmlFAmmhWlZYVG5mmcgPw"
                publishable-key="pk_live_51S6gmNFAmmhWlZYVMFwye9MNwonSWwZD9WIGfgKPoawM23qMWB5Xi6LHdpaa1IQafYNQ20wj5Okhfz17R71jP8aq0041Il9sJ6"
              >
              </stripe-buy-button>
            </div>
          </div>
        </div>
      </header>

      <ChatInterface />

      <footer className="footer">
        <p>
          Need help? <a href="mailto:admin@prayerflow.org" className="contact-link">Contact us</a>
        </p>
        <p className="copyright">
          © 2025 Othoniel Joseph. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
